import React, {useEffect, useState} from 'react';
import {DataGrid} from '@mui/x-data-grid';
import {Box, styled, Typography} from '@mui/material';
import {useNavigate} from "react-router-dom";
import DefendantProfileDialog from "./DefendantProfileDialog";
import {useClient} from "../core/client";

const columns = [
    { field: 'first', headerName: 'First', width: 150 },
    { field: 'last', headerName: 'Last', width: 150 },
    { field: 'phone', headerName: 'Phone', width: 150 },
    { field: 'email', headerName: 'Email', width: 300 },
    // Add more columns as needed
];

const StyledGridOverlay = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    '& .no-rows-primary': {
        fill: '#3D4751',
        ...theme.applyStyles('light', {
            fill: '#AEB8C2',
        }),
    },
    '& .no-rows-secondary': {
        fill: '#1D2126',
        ...theme.applyStyles('light', {
            fill: '#E8EAED',
        }),
    },
}));

function NoDefendantsOverlay() {
    return (
        <StyledGridOverlay>
            <Box sx={{ mt: 2 }}>No Defendants! Add a Defendant to get started!</Box>
        </StyledGridOverlay>
    );
}
const DefendantGrid = ({ autoHeight = false, refreshKey = 0 }) => {
    const [defendants, setDefendants] = useState([]);
    const [selectedDefendantId, setSelectedDefendantId] = useState(null);
    const client = useClient();
    const navigate = useNavigate();


    useEffect(() => {
        const fetchDefendants = async () => {
            try {
                const response = await client.get('/defendants');
                setDefendants(response.data);
            } catch (error) {
                console.error('Error fetching defendants', error);
            }
        };

        fetchDefendants();
    }, [client, refreshKey]);

    const handleRowClick = (params) => {
        // setSelectedDefendantId(params.id);
        navigate(`/defendant/${params.id}`);
    };

    const handleCloseDialog = () => {
        setSelectedDefendantId(null);
    };

    return (
        <Box sx={{ width: '100%', ...(autoHeight ? {} : { height: 400 }) }}>
            <Typography variant="h6" gutterBottom>
                Defendants List
            </Typography>
            <DataGrid
                rows={defendants}
                columns={columns}
                pageSize={5}
                autoHeight={autoHeight}
                slots={{
                    noRowsOverlay: NoDefendantsOverlay,
                }}
                rowsPerPageOptions={[5, 10, 20]}
                disableSelectionOnClick
                onRowClick={handleRowClick}
            />
            {selectedDefendantId && (
                <DefendantProfileDialog
                    open={!!selectedDefendantId}
                    onClose={handleCloseDialog}
                    id={selectedDefendantId}
                />
            )}
        </Box>
    );
};

export default DefendantGrid;
